////////////////////////////////////////////////////////////////////////////////////////
//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
//	1. 'this' changed to 'window'
////////////////////////////////////////////////////////////////////////////////////////
if (!window.cc_View) {
	window.cc_View = {};
}

(function () {
	"use strict";
	
	cc_View.blankSelectedOption = '<option value="" selected></option>';
	cc_View.dayOptions = cc_View.blankSelectedOption;
	cc_View.monthOptions = cc_View.blankSelectedOption;

	for(var i = 1; i <= 12; i++) {
		cc_View.monthOptions += '<option value="' + i + '">' + i +'</option>';
	};

	for(var i = 1; i <= 31; i++) {
		cc_View.dayOptions += '<option value="' + i + '">' + i +'</option>';
	};
	
	cc_View.currentDate = new Date();
	cc_View.currentYear = cc_View.currentDate.getFullYear();
	cc_View.currentMonthOfYear = cc_View.currentDate.getMonth() + 1;
	cc_View.currentDayOfMonth = cc_View.currentDate.getDate();

	cc_View.getPageNavigatorItemId = function (pageId) {
		return 'navigator_item_' + cc_Util.toWebSafeId(pageId);
	};
	
	cc_View.getPageDivId = function (pageId) {
		return 'page_' + cc_Util.toWebSafeId(pageId);
	};
	
	cc_View.getQuestionPanelDivId = function (questionId) {
		return 'question_' + cc_Util.toWebSafeId(questionId);
	};
	
	cc_View.findResultPanelById = function (id) {
		return $('.questionResultContainer [cc-result-panel=' + id + ']');
	};
	
	cc_View.findErrorPanelById = function (id) {
		return $('.questionErrorContainer [cc-error-panel=' + id + ']');
	};
	
	cc_View.createResultMessage = function (result) {
		return '<div class="result_text">' + result + '</div>';
	};
	
	cc_View.createErrorMessage = function (message, raisedBy) {
		// raised by should be either 'server' or 'client'
		return '<div class="errorText" data-raised-by="' + (raisedBy ? raisedBy : 'server') + '">' + message + '</div>';
	};

	cc_View.createQuickfillDefaultScreen = function () {
		return 	'<div id="cloudcase-form-container">' +
					'<div id="cloudcase-page-container">' +
						'<div id="page">' +
							'<div id="page-content" class="panel-group"></div>' +
						'</div>' +
					'</div>' +
				'</div>';
	};
	
	cc_View.createPage = function (page) {
		return 	'<div id="' + cc_View.getPageDivId(page.id) + '" cc-page-id="' + page.id + '" cc-page-index="' + page.pageIndex + '" class="panel panel-default">' +
					'<div class="panel-heading peer">' +
						'<h4 class="panel-title">' +
							'<a data-toggle="collapse" data-parent="#accordion" href="#' + page.id + '">' + page.text + '</a>' +
						'</h4>' +
					'</div>' +
					'<div id="' + page.id + '" class="panel-collapse collapse questions">' +
						'<div class="panel-body">' +
							'<div class="sections-container">' +
							'</div>' +
						'</div>' +
					'</div>' +
				'</div>';
	};

	cc_View.createPageNavigatorItem = function (page) {
		var navigatorItemId = cc_View.getPageNavigatorItemId(page.id);

		return '<li id="' + navigatorItemId + '" class="page_navigator_item" cc-page-id="' + cc_Util.toWebSafeId(page.id) + '">' +
					cc_View.createPageNavigatorPlaceholderIcon() +
				 	'<a id="' + navigatorItemId + '_link">' + page.text + '</a>' + 
				'</li>';
	};

	cc_View.createPageGroupNavigatorItem = function (pageGroupId, pageNavigator) {
		var icon;
		if (cc_UI.pageGroupHasErrors(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorErrorIcon(pageGroupId);
		} else if (cc_UI.pageGroupHasWarnings(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorWarningIcon(pageGroupId);
		} else if (cc_UI.pageGroupIsCompleted(pageGroupId, pageNavigator)) {
			icon = cc_View.createPageNavigatorCompletedIcon(pageGroupId);
		} else {
			icon = cc_View.createPageNavigatorPlaceholderIcon();
		}

		var navigatorItemId = cc_View.getPageNavigatorItemId(pageGroupId);
		return '' +
			'<li id="' + navigatorItemId + '" class="page_group_navigator_item" cc-page-group-id="' + cc_Util.toWebSafeId(pageGroupId) + '">' +
				'<div class="flex page_group_navigator_item_name">' +
					icon +
					'<a>' + pageGroupId + '</a>' +
				'</div>' +
				'<div class="chevron"></div>' +
			'</li>'
	}

	cc_View.createPageNavigatorCompletedIcon = function (pageId) {
		return	'<i class="completedIcon" cc-page-completed="' + pageId + '" title="This page is complete">' +
					cc_Icon.completedIcon() +
				'</i>';
	};

	cc_View.createPageNavigatorErrorIcon = function (pageId) {
		return	'<i class="errorIcon" cc-page-error="' + pageId + '"title="This page contains errors">' +
					cc_Icon.errorIcon() +
				'</i>';
	};

	cc_View.createPageNavigatorWarningIcon = function (pageId) {
		return	'<i class="warningIcon" cc-page-warning="' + pageId + '"title="This page contains new questions">' +
					cc_Icon.warningIcon() +
				'</i>';
	};

	cc_View.createPageNavigatorPlaceholderIcon = function() {
		return	'<i class="placeholderIcon">' +
					cc_Icon.placeholderIcon() +
				'</i>';

	}

	cc_View.createPageNavigatorActiveEditIcon = function() {
		return '<i class="activeEditIcon">' +
					cc_Icon.activeEditIcon() +
				'</i>';
	}
	
	/////////////////////////////////////////////////////////////////////////////////////////
	//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
	//	1. 'save' button removed
	//	2. add 'save' button for mobile version
	////////////////////////////////////////////////////////////////////////////////////////
	cc_View.createButtonPanel = function(isInterviewComplete, next, previous, save){
		// don't include buttons where there is no button text, as button has been excluded
		let html =  `
		<div class='buttonPanelContainer'>
				<div class="buttonPanel">
					<div class='leftButtonPanel'>
						${(previous ? "<button class='btn previous'><i class='fa fa-angle-left'></i> " + previous + "</button>" : '')}
					</div>
					<div class='rightButtonPanel'>
						${(next ? "<button class='btn btn-primary long next'>" + next + " <i class='fa fa-angle-right'></i></button>" : '')}
					</div>
				</div>

			`;

		if(previous) {
				html += `
				<div class="block lg:hidden">
					<button class='btn save'>
					<svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
						<path d="M3.15015 0.851562C1.88942 0.851562 0.851562 1.88945 0.851562 3.15013V13.8863C0.851562 15.1478 1.88946 16.1849 3.15015 16.1849H13.8878C15.1492 16.1849 16.1849 15.147 16.1849 13.8863V4.68398C16.1863 4.48056 16.1073 4.28506 15.9649 4.1406L12.8965 1.07216C12.8009 0.978725 12.683 0.912598 12.5536 0.878813L3.15015 0.851562ZM3.15015 2.38539H3.91996V6.21781C3.92139 6.63901 4.26281 6.97969 4.684 6.98184H12.3533C12.7745 6.9804 13.1152 6.63899 13.1174 6.21781V3.46494L14.6527 5.00022V13.887C14.6527 14.3247 14.3271 14.6525 13.8886 14.6525L3.15028 14.6511C2.71255 14.6511 2.38624 14.324 2.38624 13.8856V3.14937C2.38624 2.71093 2.71183 2.38388 3.15028 2.38388L3.15015 2.38539ZM5.45316 2.38539H11.5827V5.45383H5.45316V2.38539ZM4.68335 8.51637C4.26 8.51781 3.91786 8.86281 3.91931 9.28617V12.3531C3.92075 12.7743 4.26217 13.115 4.68335 13.1172H12.3527C12.7739 13.1157 13.1146 12.7743 13.1167 12.3531V9.28617C13.1182 8.86281 12.7767 8.51781 12.3527 8.51637H4.68335ZM5.45316 10.0502H11.5827V11.584H5.45316V10.0502Z"/>
					</svg>
					<span>Save & Exit</span>
					</button>
				</div>
				`;
		}

		html += `</div>`;

		return html;
	};

	/////////////////////////////////////////////////////////////////////////////////////////
	//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
	//	1. completely replaced it with the old TSB footer (v14.0)
	////////////////////////////////////////////////////////////////////////////////////////
	cc_View.createFooter = function(){
		return `
		<footer>
			<div class="footer-logo">
				<a href="https://www.tsb.co.nz/" target="_blank">
					<svg width="96" height="24" viewBox="0 0 108 27" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M51.7402 7.84704H46.825V4.33105H61.9704V7.84704H57.0552V22.1156H51.7402V7.84704Z" fill="#1A1C45" />
						<path d="M64.6411 17.7328C66.013 18.395 67.9275 18.9053 70.1278 18.9053C71.8136 18.9053 73.4143 18.599 73.4143 17.1721C73.4143 13.8601 63.9836 15.9492 63.9836 9.4772C63.9836 5.19735 68.6701 4.0249 72.6709 4.0249C74.5862 4.0249 76.4719 4.27999 77.8149 4.68788L77.822 8.35663C76.4501 7.79598 74.5574 7.54086 73.0426 7.54086C71.6996 7.54086 69.4712 7.64322 69.4712 9.19723C69.4712 12.0765 78.9011 10.1402 78.9011 16.5603C78.9011 21.1727 74.5574 22.4212 70.1279 22.4212C68.2703 22.4212 66.2816 22.1661 64.5092 21.6567L64.6411 17.7328Z" fill="#1A1C45" />
						<path d="M81.6141 4.33105H90.787C94.5021 4.33105 97.274 5.78349 97.274 8.84114C97.274 11.083 95.988 12.3315 93.7596 12.9938V13.045C96.4167 13.5289 97.7886 14.803 97.7886 16.9681C97.7886 21.2238 93.5878 22.1156 90.0156 22.1156H81.6141V4.33105ZM86.929 11.363H88.4157C90.1585 11.363 91.959 10.9807 91.959 9.47784C91.959 7.84704 90.2444 7.69427 88.4727 7.69427H86.929V11.363ZM86.929 18.7524H88.5008C90.4443 18.7524 92.4736 18.4973 92.4736 16.6881C92.4736 14.7518 90.3873 14.5734 88.5578 14.5734H86.929V18.7524Z" fill="#1A1C45" />
						<path d="M23.4126 12.6063V0C18.2303 7.25708 9.76168 12.2877 0 13.2233C9.76168 14.1582 18.2303 19.1887 23.4126 26.4465V13.8395C17.5393 13.8416 11.8019 13.5712 6.21369 13.2233C11.8019 12.8746 17.5393 12.6034 23.4126 12.6063Z" fill="#0B794B" />
						<path d="M23.4124 12.6063V0C28.5954 7.25708 37.0632 12.2877 46.8249 13.2233C37.0632 14.1582 28.5954 19.1887 23.4124 26.4465V13.8395C29.2856 13.8416 35.023 13.5712 40.6112 13.2233C35.023 12.8746 29.2856 12.6034 23.4124 12.6063Z" fill="#29B58B" />
					</svg>
				</a>
			</div>
			<div class="footer-nav-items">
				<a href="https://www.tsb.co.nz/information" class="nav-link" target="_blank" title="Terms &amp; Conditions">Terms &amp; Conditions</a>
				<a href="https://www.tsb.co.nz/about/financial-information" class="nav-link" target="_blank" title="Disclosure Statement">Disclosure Statement</a>
				<a href="https://www.tsb.co.nz/privacy-policy" class="nav-link" target="_blank" title="Privacy">Privacy</a>
				<a href="https://www.tsb.co.nz/security-tips" class="nav-link" target="_blank" title="Security Tips">Security Tips</a>
				<a href="https://www.tsb.co.nz/fees/account-service" class="nav-link" target="_blank" title="Fees">Rates, Fees & Agreements</a>
			</div>
			<div class="footer-policy">
				<p>
					© TSB BANK LIMITED 2008-2022. Use of this website is subject to our <a href="https://www.tsb.co.nz/information/website-policy" class="nav-link" target="_blank">Website Policy</a>.
					TSB BANK Limited is in trade for the purposes of the Fair Trading Act 1986.
				</p>
			</div>
		</footer>`;
	}
	
	cc_View.getSectionDivId = function (pageId, section) {
		return 'id_section_' + cc_Util.toWebSafeId(pageId) + '_' + cc_Util.toWebSafeId(section);
	};
	
	cc_View.createSection = function (pageId, section) {
		var html = '<div id="' + cc_View.getSectionFieldsetId(pageId, section) + '" class="sectionHeader">';
		
		if(section){
			html +=		'<legend>' + section + '</legend>';
		}
		
		html +=			'<div id="' + cc_View.getSectionDivId(pageId, section) + '"></div>' +
					'</div>';
		
		return html;
	};
	
	cc_View.getSectionFieldsetId = function (pageId, section) {
		return 'fieldset_section_' + cc_Util.toWebSafeId(pageId) + '_' + cc_Util.toWebSafeId(section);
	};

	cc_View.isViewableQuestion = function (question) {
		var hasValue = function(value){
			return (value != null && value.length > 0);
		};

		return question && (hasValue(question.text) || hasValue(question.values) || hasValue(question.entered) ||
			hasValue(question.error) || question.type.hasAnEnterableType || cc_Model.getProperty(cc_Renderer.PROPERTY_PLACEHOLDER, question) != null);
	};
	
	cc_View.createQuestionHtml = function (question) {	
		var classes = 'questionPanel ';
		classes += cc_Model.getProperty(cc_Renderer.PROPERTY_PANEL_CLASSES, question) ?  cc_Model.getProperty(cc_Renderer.PROPERTY_PANEL_CLASSES, question)  + " " : "";
		
		classes += ' ' + cc_View.createQuestionPanelComponentVisibilityClasses(question).join(' ');
		
		if(question.concealed == true){
			classes += ' concealed';
		}
		
		if(cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT, question) == 'Horizontal'){
			classes += ' layoutHorizontal';
		}
		
		var html = '<div id="' + cc_View.getQuestionPanelDivId(question.id) + '" cc-panel="' + question.id + '" class="' + classes + '">';
		
		if (question.type.hasAnInputType) {
			switch (question.type.value) {
			case 'multi-select':
				html += cc_View.createMultiSelectQuestionHtml(question);
				break;
			case 'single-select':
			case 'boolean':
				html += cc_View.createSingleSelectQuestionHtml(question);
				break;
			case 'free-text':
				html += cc_View.createFreeTextQuestionHtml(question);
				break;
			case 'number':
			case 'range':
				html += cc_View.createNumberQuestionHtml(question);
				break;
			case 'date':
				html += cc_View.createDateQuestionHtml(question);
				break;
			case 'search':
				html += cc_View.createSearchQuestionHtml(question);
				break;
			case 'add-document':
				html += cc_View.createAddDocumentQuestionHtml(question);
				break;
			case 'external-widget':
				html += cc_View.createExternalWidgetQuestionHtml(question);
				break;
			}
			
		}else {
			const text = cc_View.createQuestionText(question);

			switch (cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question)) {
				case 'Explainer':
					html += `<div class="text-explainer questionPanel p-small">${(text ? text : '')}</div>`;
					break;
				case 'Emphasis':
					html += `<div class="text-emphasis">${(text ? text : '')}</div>`;
					break;
				case 'PageTitle':
					html += `<h1>${(text ? text : '')}</h1>`;
					break;
				default:
					html += '<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						cc_View.createQuestionHelpPanelHtml(question) +
						cc_View.createQuestionResultAndErrorPanelHtml(question) +
						'</div>';
			}
		}
	
		if (question.hasSubQuestions) {
			html += cc_View.createSubQuestionsHtml(question);
		}
		
		html += '</div>';
		
		return html;
	};
	
	cc_View.createQuestionPanelComponentVisibilityClasses = function (question) { // question can be null

		// NOTE: cc_Renderer.registerQuestionPanelUpdate() requires that all classes start with either 'shown' or 'hidden' or 'disabled'
		
		var hasValue = function(value){
			return (value != null && value.length > 0);
		};
		
		var classes = [];
		var isQuestionTriggerType = cc_Model.task ? cc_Model.task.triggerType === 'QUESTION_TRIGGER' : false;
		
		var shownQuestionPanel = question && cc_View.isViewableQuestion(question) == true;
		classes.push(shownQuestionPanel ? 'shownQuestionPanel' : 'hiddenQuestionPanel');
		
		var shownQuestionTextPanel = question && hasValue(question.text);
		classes.push(shownQuestionTextPanel ? 'shownQuestionTextPanel' : 'hiddenQuestionTextPanel');

		var disabledQuestionContentPanel = question && question.disabled;
		if (disabledQuestionContentPanel === true) {
			classes.push('disabledQuestionContentPanel');
		}
		
		var shownQuestionOutcomePanel = question && (hasValue(question.error) || hasValue(question.result));
		classes.push(shownQuestionOutcomePanel ? 'shownQuestionOutcomePanel' : 'hiddenQuestionOutcomePanel');
		
		var hasTextAndEnterable = question && hasValue(question.text) && question.type.hasAnEnterableType;
		classes.push(hasTextAndEnterable ? 'shownTextAndEnterable' : 'hiddenTextOrEnterable');
		
		var hiddenTextAndEnterable = question && hasValue(question.text) === false && question.type.hasAnEnterableType === false;
		if(hiddenTextAndEnterable === true){
			classes.push('hiddenTextAndEnterable');
		}
		
		return classes;
	};

	cc_View.createQuestionHeadingHtml = function (question) {
		var text = cc_View.createQuestionText(question);
		
		// when question does not include a text value still attach the questionText elements
		// as the value can be modified via a CC.getQuestion().setText() call.
		// without the questionText added the text value modifications will never be displayed

		//branding update October 2024 removed helptext icon

		return '' +
			'<div class="questionAnnotationsAndText">' +
				'<div class="questionHeadingContainer">' +
					'<div class="questionText prose" data-cc-required="' + (question.mustAnswer ? 'true' : 'false') + '" cc-text="' + question.id + '">' +
						'<span>' + (text ? text : '') + '</span>' +
					'</div>' +
					(text && text.replace('&nbsp;', '') ? ''
						// '<div class="questionAnnotations">' +
							// cc_View.createQuestionHeadingMustAnswerHtml(question.mustAnswer) +
							// cc_View.createQuestionHeadingOptionalHtml(question) +
						// '</div>'
						: ''
					) +
				'</div>' +
			'</div>';
	};
	
	cc_View.createQuestionHeadingMustAnswerHtml = function (isMustAnswer) {
		// Intentionally blocking the "required" annotation because it is not currently needed
		// but the styling of it is prepared for when we want it
		if (!cc_Config.showQuestionOptionalAnnotation && isMustAnswer) {
			return '<div class="text-error">*</div>'
		// if (false && isMustAnswer) {
		// 	return	"<div class='question-mandatory-pill__container'>" +
		// 				"<span class='question-pill__inner'>Required</span>" +
		// 			"</div>";
		} else {
			return '';
		}
	};

	cc_View.createQuestionHeadingOptionalHtml = function (question) {
		if (cc_Config.showQuestionOptionalAnnotation && !question.mustAnswer) {
			if (question.type.value === 'type-less') {
				return '';
			} else {
				return	"<div class='question-optional-pill__container'>" +
							"<span class='question-pill__inner'>Optional</span>" +
						"</div>";
			}
		} else {
			return '';
		}
	}
	
	cc_View.createMultiSelectQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html = 
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, question.text ? 'fixedWidthQuestion' : 'floatingWidthQuestion') + '" cc-type="' + question.type.value + '">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">' +
						'<div class="multiAnswerGroup" cc-group-question-id="' + question.id + '">';

		html += 			cc_View.createMultiSelectOptionsHtml(question);
	
		html +=			'</div>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
			
		return html;
	};

	////////////////////////////////////////////////////////////////////////////////////////
	//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
	//	1. 'cc_View.createMultiSelectOptionsHtml' completely changed
	////////////////////////////////////////////////////////////////////////////////////////
	cc_View.createMultiSelectOptionsHtml = function (question) {
		var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);
		var parentClassName = "";
		var isAddButtonStyle = styleProperty === "AddButton";
		var html = '';

		if (isAddButtonStyle) {
			html += '<div class="btn-group ' + parentClassName + '" data-toggle="buttons">';
		}
		
		$.each(question.values, function (i) {
			var optionId = question.id + '_' + cc_Util.escapeHtmlAttributeValue(this.value);
			var infoPicUrl = cc_Model.getProperty("InfoPicUrl" + (i + 1), question);

			if (isAddButtonStyle) {
				html += '<label class="btn btn-lg btn-default" for="' + optionId + '" cc-disableable="' + question.id + '">';

				if (infoPicUrl) {
					html += '<span class="info-pic">' +
						'<img src="' + infoPicUrl + '" class="info-pic">' +
						'</span>';
				}

				html += '<input id="' + optionId + '" type="checkbox" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
					'<span>' + this.value + '</span>' +
					'<i class="checked fa fa-plus"></i>' +
					'<i class="unchecked fa fa-check"></i>' +
					'</label>';
			} else {
				html += '' +
					'<div class="checkbox-inline">' +
					'<input id="' + optionId + '" type="checkbox" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
					'<label class="answerText unselectable" for="' + optionId + '">' + this.value + '</label>' +
					'</div>';
			}
		});

		if (isAddButtonStyle) {
			html += '</div>';
		}
		
		return html;
	};
	
	cc_View.createSingleSelectQuestionHtml = function (question) {
		if(question.type.value == 'boolean' || question.type.styleName == 'radio'){
			return cc_View.createSingleSelectRadioQuestionHtml(question);
			
		}else{
			return cc_View.createSingleSelectListQuestionHtml(question);
		}
	};
	
	cc_View.createSingleSelectListQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";
		var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);

		var html =
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="list">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">';

		if(question.type.styleName == 'auto-complete'){
			if (styleProperty === "DropDownType" || styleProperty === "ExpenseGroupSelectInput") {
				html += '<input class="drop-down-type form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" readonly cc-style="auto-complete" ' + cc_View.createQuestionPlaceholder(question) + '/>';
			} else {
				html += '<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="auto-complete" ' + cc_View.createQuestionPlaceholder(question) + '/>';
			}
			
		}else{
			html +=		'<select class="form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="list">';

			html += 		cc_View.createSingleSelectListOptionsHtml(question);
					
			html +=		'</select>';
		}
		
		html +=		'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
			
		return html;
	};
	
	cc_View.createSingleSelectListOptionsHtml = function (question) {
		var html = '<option value="" selected></option>';
		
		$.each(question.values, function () {
			html += '<option value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" class="dropdown-item">' + this.value +'</option>';
			return true;
		});
		
		return html;
	};
	
	cc_View.createSingleSelectRadioQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html = 
				'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, question.text ? 'fixedWidthQuestion' : 'floatingWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="radio">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass +'">' +
						'<div class="multiAnswerGroup" cc-group-question-id="' + question.id + '">';

		html += 			cc_View.createSingleSelectRadioOptionsHtml(question);
							
		html +=			'</div>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
		return html;
	};
	
	/////////////////////////////////////////////////////////////////////////////////////////
	//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
	//	1. 'cc_View.createSingleSelectRadioOptionsHtml' completely changed
	////////////////////////////////////////////////////////////////////////////////////////
	cc_View.createSingleSelectRadioOptionsHtml = function (question) {

        var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);
        var className = "";
		var parentClassName = "";
		var isButtonStyle = styleProperty === "ButtonGroup";
		className += (styleProperty === "TwoOptionsRadio" || question.type.value === 'boolean') ? "two-options " : "";

		if (cc_Model.getProperty(cc_Renderer.PROPERTY_WRAP, question) === "None") {
			className = " flex-nowrap ";
		}
        var html = '';

        if (isButtonStyle) {
            html += '<div class="btn-group ' + parentClassName + '" data-toggle="buttons">';
        } else if (styleProperty !== "Confirm") {
			html += '<div class="radio-group ' + className + '">';
		}

        $.each(question.values, function (i) {
            var optionId = question.id + '_' + cc_Util.escapeHtmlAttributeValue(this.value);
            var infoPicUrl = cc_Model.getProperty("InfoPicUrl" + (i + 1), question);

            if (isButtonStyle) {
				html += '<label class="btn btn-lg btn-default ' + className + '" for="' + optionId + '" cc-disableable="' + question.id + '">';

                if (infoPicUrl) {
                    html += '<span class="info-pic">' +
                        '<img src="' + infoPicUrl + '" class="info-pic">' +
                        '</span>';
                }

                html += '<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
						'<span>' + this.value + '</span>' +
                    '</label>';
            } else if (styleProperty == "Confirm") {
                html += '<div class="radio-inline">' +
                    '<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
                    '<label class="answerText unselectable" for="' + optionId + '" >' + this.value + '</label>' +
                    '</div>';
            } else {
				html += '<div class="radio-container "><label class="radio-label" for="' + optionId + '" cc-disableable="' + question.id + '">';

				if (infoPicUrl) {
					html += '<span class="info-pic">' +
						'<img src="' + infoPicUrl + '" class="info-pic">' +
						'</span>';
				}

				html += '<input id="' + optionId + '" type="radio" name="' + question.id + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" value="' + cc_Util.escapeHtmlAttributeValue(this.value) + '" />' +
					'<i class="unchecked fa fa-circle-o"></i>' +
					'<i class="checked fa fa-check"></i>' +
					'<span>' + this.value + '</span>' +
					'</label></div>';
			}
        });

        if (isButtonStyle || styleProperty !== "Confirm") {
            html += '</div>';
        }

        return html;
    };
	
	cc_View.createSearchQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		var html =
			'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
				cc_View.createQuestionHeadingHtml(question) +
				'<div class="questionContent ' + disabledOutputClass +'">' +
					'<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" cc-style="auto-complete" ' + cc_View.createQuestionPlaceholder(question) + '/>' +
					'<div class="searchAction searchEditContent" cc-hideable-panel="' + question.id + '">' +
						'<input cc-search-edit-button="' + question.id + '" class="editSearchButton btn btn-primary small" type="button" value="Edit" />' +
					'</div>' +
				'</div>' +
				'<div class="searchAction searchAgainContent" cc-hideable-panel="' + question.id + '">' +
					'<a class="searchAgainLink"><span class="cursor-pointer underline text-teal">Click here</span><span> to search again</span></a>' +
				'</div>';
		if(question.type.searchMatch.required === false && question.type.searchMatch.noMatchText){
			html +=	'' +
				'<div cc-hideable-panel="' + question.id + '" class="searchAction searchNoMatchContent">' +
					'<a class="searchNoMatchLink cursor-pointer">' + question.type.searchMatch.noMatchText + '</a>' +
				'</div>';
		}
		html += cc_View.createQuestionHelpPanelHtml(question) +
				cc_View.createQuestionResultAndErrorPanelHtml(question) +
			'</div>';
			
		return html;
	};

	cc_View.createNumberQuestionHtml = function (question) {
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";

		return 	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
					cc_View.createQuestionHeadingHtml(question) +
					'<div class="questionContent ' + disabledOutputClass + '">' +
						'<input class="form-control" type="' + (cc_UI.isMobileDevice() === true ? 'number' : 'text') + '" cc-field="' +
							question.id + '" cc-disableable="' + question.id + '" style="display:none" />' +
						'<input class="form-control" type="text" cc-decorator-field="' +
							question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>' +
					'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
	};
	
	cc_View.createFreeTextQuestionHtml = function (question) {
		var isFullWidthQuestion = question.type.styleName == 'text-area';
		var styleProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_STYLE, question);
		var isDisabledOutput = cc_Model.getProperty(cc_Renderer.PROPERTY_DISABLED_OUTPUT, question) === "true";
		var disabledOutputClass = isDisabledOutput ? "disabledOutput" : "";
		
		var html = '<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, isFullWidthQuestion == true ? 'fullWidthQuestion' : 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '" cc-style="' + question.type.styleName + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						'<div class="questionContent ' + disabledOutputClass + '">';
		
		if(question.type.styleName == 'text-area'){
			var heightProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_HEIGHT, question);
			
			html +=		'<textarea class="text form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) +
							(heightProperty ? ' style="height:' + heightProperty + ';"' : '') + 
						'></textarea>';
		}else if(styleProperty == 'Password'){
			html += 	'<input class="form-control" type="password" name="password-' + cc_Util.toWebSafeId(question.id) + '" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>';
		}else{
			html += 	'<input class="form-control" type="text" cc-field="' + question.id + '" cc-disableable="' + question.id + '" ' + cc_View.createQuestionPlaceholder(question) + '/>';
		}
		
		html += 	'</div>' +
					cc_View.createQuestionHelpPanelHtml(question) +
					cc_View.createQuestionResultAndErrorPanelHtml(question) +
				'</div>';
		
		return html;
	};
	
	cc_View.createSubQuestionsHtml = function (question) {
		var html = '';
		
		if(question.subQuestions && question.subQuestions.length > 0){
			cc_Util.invokeOnElements(question.subQuestions, function () {
				html += cc_View.createQuestionHtml(this);
			});
		}
		
		return html;
	};
	
	cc_View.createExternalWidgetQuestionHtml = function (question) {
		var html = 	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fullWidthQuestion') + '" cc-type="' + question.type.value + '">';

		html +=	'' +
			cc_View.createQuestionHelpPanelHtml(question) +
			cc_View.createQuestionResultAndErrorPanelHtml(question);

		var renderedQuestionHtml = eval(question.type.externalWidget.renderFunktion + ';' + question.type.externalWidget.renderFunktionName + '();');
		if(renderedQuestionHtml){
			html += renderedQuestionHtml;
		}

		html +=		'</div>';
		
		return html;
	};
	
	cc_View.createAddDocumentQuestionHtml = function (question) {
		// TODO check disabledness for documents

		return 	'<form>' +
					'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion') + '" cc-type="' + question.type.value + '">' +
						cc_View.createQuestionHeadingHtml(question) +
						'<div class="questionContent"></div>' +
						cc_View.createQuestionHelpPanelHtml(question) +
						cc_View.createQuestionResultAndErrorPanelHtml(question) +
					'</div>'+
				'</form>';
	};

	cc_View.createAddDocumentQuestionContentHtml = function (question) {
		var html;

		if(cc_Config.isExecutingWithinWorkflow === true){

			// entered can be null for multiple answer questions
			if(question.entered && question.entered.length == 2){
				html = '<div class="addedDocumentPanel">' +
							'<div class="flex gap-2.5 items-center">' +
								'<i>' +
									'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
										'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
									'</svg>' +
								'</i>' +
								'<span>' + question.entered[1] + '</span>' +
							'</div>' +
							'<div>' +
								'<input cc-disableable="' + question.id + '" cc-field="' + question.id + '" value="' + question.entered[0] + cc_Config.fieldDelimiter + question.entered[1] + '" type="hidden" />' +
								'<input cc-disableable="' + question.id + '" class="removeDocumentButton"' + ' data-documentid="' + question.entered[0] + '" class="btn btn-primary" type="button" value="Remove" />' +
							'</div>';
					'</div>';
			}else{
				html = 	'<label class="filePanel">' +
							'<div class="missingDocumentPanel">' +
								'<div class="flex gap-2.5 items-center">' +
									'<i>' +
										'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
											'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
										'</svg>' +
									'</i>' +
									'<span>No file uploaded</span>' +
								'</div>' +
								'<div>' +
									'<input cc-disableable="' + question.id + '" name="environment" type="hidden" value="' + cc_Config.environment + '" />' +
									'<input cc-disableable="' + question.id + '" name="workflowName" type="hidden" value="' + cc_Config.workflowName + '" />' +
									'<input cc-disableable="' + question.id + '" name="workflowVersion" type="hidden" value="' + cc_Config.workflowVersion + '" />' +
									'<input id="' + question.id + '" style="display:none;" cc-disableable="' + question.id + '" cc-field="' + question.id + '" name="document" class="uploadDocumentFile btn btn-default peer" type="file" />' +
									'<label for="' + question.id + '" class="uploadDocumentButton">Choose</label>' +
								'</div>' +
							'</div>' +
						'</label>';
			}
		}else{
			html = '<div class="missingDocumentPanel" >' +
						'<div class="flex gap-2.5 items-center">' +
							'<i>' +
								'<svg width="27" height="33" viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg">' +
									'<path fill-rule="evenodd" clip-rule="evenodd" d="M13.9714 0.466947V7.3968C13.9714 9.52883 15.6996 11.2571 17.8317 11.2571H26.2688C26.305 11.4697 26.3235 11.6865 26.3235 11.9055V29.0109C26.3235 31.143 24.5953 32.8712 22.4633 32.8712H3.93642C1.80439 32.8712 0.0761719 31.143 0.0761719 29.0109L0.076209 4.30947C0.076209 2.17744 1.80443 0.449219 3.93646 0.449219H13.6023C13.726 0.449219 13.8492 0.455177 13.9714 0.466947ZM15.5158 0.957387V7.3968C15.5158 8.6763 16.5522 9.71266 17.8317 9.71266H25.6405C25.4532 9.44145 25.2301 9.19289 24.9745 8.97445L16.1135 1.37845C15.927 1.21854 15.7267 1.0778 15.5158 0.957387Z" fill="currentColor"></path>' +
								'</svg>' +
							'</i>' +
							'<span class="font-bold">Add Document question is not supported in rulebook test mode.</span>' +
						'</div>' +
					'</div>';
		}

		return html;
	};

	/////////////////////////////////////////////////////////////////////////////////////////
	//	UI_CUSTOM_CHANGES - to make merging on upgrades easier, please update as you make changes:
	//	1. 'cc_View.createDateQuestionHtml' has been completely changed to include the datepicker
	////////////////////////////////////////////////////////////////////////////////////////
	cc_View.createDateQuestionHtml = function (question) {
		return	'<div class="questionContainer ' + cc_View.getQuestionLayoutTextPosition(question, 'fixedWidthQuestion')  + '" cc-type="' + question.type.value + '">' +
			cc_View.createQuestionHeadingHtml(question) +
			'<div class="questionContent">' +
			'<div class="input-group date">' +
			'<input  type="text" class="form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '">' +
			'</div>' +
			'</div>' +
			cc_View.createQuestionResultAndErrorPanelHtml(question) +
			cc_View.createQuestionHelpPanelHtml(question) +
			'</div>';
	};
	
	cc_View.createQuestionResultAndErrorPanelHtml = function (question) {
		// this method can be called in two situations:
		//	1. as a next question being attached for the first time
		//	2. when a sub question is being added as a next question
		//
		// for case 2. the sub question's root parent is re-rendered. 
		//
		// an error should only be shown via this mechanism when it is being attached for the first
		// time, so it had not been viewed. this only occurs when the query interface method setError()
		// is run on a newly asked question
		var allowErrorToBeShown = question.viewed === false;
		
		return	'<div class="questionOutcomeContainer">' +
					'<div class="questionResultContainer">' + cc_View.createQuestionResult(question) + '</div>' +
					'<div class="questionErrorContainer">' + cc_View.createQuestionError(question, allowErrorToBeShown) + '</div>' +
				'</div>';
	};
	
	cc_View.createQuestionHelpPanelHtml = function (question) {
		var html = '';

		var helpText = cc_Model.getProperty(cc_Renderer.PROPERTY_HELP_TEXT, question);
		if(helpText != null){
			html += 	'<div class="questionHelpContainer" style="display:flex;">' +
							helpText +
						'</div>';
		}
		
		return html;
	};
	
	cc_View.createQuestionHelpButtonHtml = function (question) {
		var html = '';

		if (question.type.value !== 'type-less') {
			var helpText = cc_Model.getProperty(cc_Renderer.PROPERTY_HELP_TEXT, question);
			if(helpText != null){
				html += 	'<div class="questionHelpButton self-center">' +
								'<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
									'<path fill-rule="evenodd" clip-rule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" fill="#285E8E"/>' +
									'<path fill-rule="evenodd" clip-rule="evenodd" d="M10 7C9.4794 7 9 7.44637 9 8.06897C9 8.62125 8.55228 9.06897 8 9.06897C7.44772 9.06897 7 8.62125 7 8.06897C7 6.40625 8.31146 5 10 5C11.6885 5 13 6.40625 13 8.06897C13 9.38575 12.1803 10.5383 11 10.9637V11.5C11 12.0523 10.5523 12.5 10 12.5C9.44772 12.5 9 12.0523 9 11.5V10.3382C9 9.70674 9.48464 9.18376 10.1095 9.13167C10.5835 9.0767 11 8.64657 11 8.06897C11 7.44637 10.5206 7 10 7Z" fill="#285E8E"/>' +
									'<path d="M11 14C11 14.5523 10.5523 15 10 15C9.44772 15 9 14.5523 9 14C9 13.4477 9.44772 13 10 13C10.5523 13 11 13.4477 11 14Z" fill="#285E8E"/>' +
								'</svg>' +
							'</div>';
			}
		}

		return html;
	};
	
	cc_View.createDateQuestionSegmentHtml = function (question, type) {
		var label, segmentHtml;
		
		if(type === 'year'){
			segmentHtml = cc_View.blankSelectedOption;
			for(var i = question.hints[3] ; i >= question.hints[2]; i--) {
				segmentHtml += '<option value="' + i + '">' + i +'</option>';
			};
			label = 'Year';
			
		}else if(type === 'month'){
			segmentHtml= cc_View.monthOptions;
			label = 'Month';
			
		}else{
			segmentHtml= cc_View.dayOptions;
			label = 'Day';
		}
		
		return '<div class="answerText flex flex-col w-28 space-y-1">' +
					'<label class="font-bold">' + label + '</label>' +
					'<select class="form-control" cc-field="' + question.id + '" cc-disableable="' + question.id + '">' + segmentHtml + '</select>' +
				'</div>';
	};
	
	cc_View.getQuestionLayoutTextPosition = function (question, defaultLayoutTextPosition) {
		var layoutTextPositionProperty = cc_Model.getProperty(cc_Renderer.PROPERTY_LAYOUT_TEXT_POSITION, question);

		var layoutTextPosition = null;
		switch(layoutTextPositionProperty) {
			case 'Full':
				layoutTextPosition = 'fullWidthQuestion';
				break;
			case 'Floating':
				layoutTextPosition = 'floatingWidthQuestion';
				break;
			case 'Fixed':
				layoutTextPosition = 'fixedWidthQuestion';
				break;
			default:
				layoutTextPosition = defaultLayoutTextPosition;
		}
		
		return layoutTextPosition;
	};
	
	cc_View.createQuestionPlaceholder = function (question){
		var placeholder = cc_Model.getProperty(cc_Renderer.PROPERTY_PLACEHOLDER, question);
		return placeholder ? 'placeholder="' + placeholder + '"' : '';
	};
	
	cc_View.createQuestionText = function (question) {
		return question.text;
	};
	
	cc_View.findQuestionPanelById = function (id, filter) {
		return $('#' + cc_View.getQuestionPanelDivId(id) + (filter || ''));
	};
	
	cc_View.findQuestionFieldById = function (id, filter) {
		return $('div.questionContent [cc-field=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionPanelByField = function (jField) {
		return $(jField).closest('.questionPanel');
	}; 
	
	cc_View.findQuestionLabelByField = function (jField) {
		return $(jField).closest('label');
	}; 
	
	cc_View.findQuestionFieldDecoratorByField = function (jField) {
		return jField.parent().find('[cc-decorator-field]');
	}; 
	
	cc_View.findQuestionTextById = function (id, filter) { 
		return $('div.questionText[cc-text=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionDisabledById = function (id, filter) { 
		return $('[cc-disableable=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionSearchNoMatchPanelById = function (id, filter) { 
		return $('[cc-search-no-match-panel=' + id + ']' + (filter || ''));
	};
	
	cc_View.findQuestionHideablePanelById = function (id, filter) { 
		return $('[cc-hideable-panel=' + id + ']' + (filter || ''));
	};
	
	cc_View.createQuestionResult = function (question) {
		return 	'<div cc-result-panel="' + question.id + '" class="result_content">' + 
					(question.result ? cc_View.createResultMessage(question.result) : '') + 
				'</div>';
	};

	cc_View.createQuestionError = function (question, allowErrorToBeShown) {
		return 	'<div cc-error-panel="' + question.id + '" class="error_content">' + 
					(question.error && allowErrorToBeShown === true ? cc_View.createErrorMessage(question.error) : '') + 
				'</div>';
	};
	
	cc_View.getContainingDialogId = function(field) {
		var containingDialog = $(field).closest(".ui-dialog-content.ui-widget-content");
		return containingDialog.length > 0 ? containingDialog[0].id : null;
	};
	
	cc_View.isShowingDialogId = function(dialogId) {
		return $('#' + dialogId + ':visible').length > 0;
	};
	
}());